'use strict';

const RE_BCP47_TAG = /^([a-z]{2,3})(-([a-z]){3}){0,3}(-([A-Z][a-z]{3}))?(-([A-Z]{2}|\d{3}))?(-([a-z0-9]{8})){0,5}$/;

const RE_SIMPLIFIED_CHINESE_REGIONS = /^(CN|SG|MY)$/;
const RE_TRADITIONAL_CHINESE_REGIONS = /^(TW|HK|MO|PH)$/;
const RE_KNOWN_CHINESE_SCRIPTS = /^Han[st]$/;

/**
 * Given any BCP47 locale string returns another valid BCP47 locale string
 * that is the "canonical" locale to use for translation that RelicLink would
 * consider distinct for purposes of translation (i.e. regional variations on
 * date formating do not require separate translations). For example "en-US" and
 * "en-CA" both resolve to just "en" whereas "zh-TW" and "zh-Hanst" both resolve
 * to "zh-Hanst".
 *
 * @param  {string} locale any BCP47 language tag
 * @return {string}        distinct BCP47 language tag
 */
module.exports = function getDistinctTranslationLocale (locale) {

  let [_0, language, _2, _extlang, _4, script, _5, region, _6, _variants] = RE_BCP47_TAG.exec(locale);

  if (language === 'zh') {
    if (script) {
      if (RE_KNOWN_CHINESE_SCRIPTS.test(script)) {
        return `zh-${script}`;
      }
    }
    if (region) {
      if (RE_SIMPLIFIED_CHINESE_REGIONS.test(region)) {
        return 'zh-Hans';
      }
      if (RE_TRADITIONAL_CHINESE_REGIONS.test(region)) {
        return 'zh-Hant';
      }
    }
    // all other Chineese variants - assume simplified:
    return 'zh-Hans';
  } else {
    // for all languages other than chinese
    return language;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-regions/getDistinctTranslationLocale.js